import { Fragment, type ReactElement, type ReactNode } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { Spacer } from "../Spacer";
import { type ListRowProps } from "./ListRow";

export interface ListProps {
  title?: ReactNode;
  titleRightElement?: ReactNode;
  rows: ReactElement<ListRowProps>[];
}

export const List = ({ title, titleRightElement, rows }: ListProps) => (
  <StyledList>
    {title && (
      <>
        <StyledTitleLine>
          <StyledTitle>{title}</StyledTitle>
          {titleRightElement}
        </StyledTitleLine>
        <Spacer y={0.75} />
      </>
    )}
    {rows.map((row, index) => (
      <Fragment key={index}>
        {index > 0 && (
          <>
            <Spacer y={0.75} />
            <StyledSeparator />
            <Spacer y={0.75} />
          </>
        )}
        {row}
      </Fragment>
    ))}
  </StyledList>
);

const StyledList = styled(StyledColumn)`
  width: 100%;
`;

const StyledTitleLine = styled(StyledFlex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

const StyledTitle = styled.span`
  ${typographies["Header/H6"]}
  color: ${colors["colors/text/darkGrey"]};
`;

const StyledSeparator = styled.div`
  border-top: 0.0625rem solid ${colors["colors/borders/separator/cells"]};
`;
